<script setup lang="ts">
  // Framework
  import { Atom } from '@vuetify/v0'

  // Constants
  import { EXTERNAL_LINK_SUFFIX } from '@/constants/links'

  // Utilities
  import { toRef } from 'vue'
  import { RouterLink } from 'vue-router'

  // Types
  import type { AtomProps } from '@vuetify/v0'

  export interface AppLinkProps extends AtomProps {
    /** Link destination - internal path or external URL */
    to: string
    /** Hide the external link suffix icon */
    noSuffix?: boolean
  }

  const { as: _as, to, noSuffix, ...props } = defineProps<AppLinkProps>()

  const isExternal = toRef(() => to.startsWith('http://') || to.startsWith('https://'))

  const as = toRef(() => isExternal.value ? 'a' : RouterLink)
  const linkProps = toRef(() => isExternal.value
    ? { href: to, target: '_blank', rel: 'noopener noreferrer' }
    : { to },
  )

  const suffix = toRef(() => !noSuffix && isExternal.value ? EXTERNAL_LINK_SUFFIX : '')
</script>

<template>
  <Atom
    :as
    class="v0-link"
    v-bind="{ ...linkProps, ...props }"
  >
    <slot />
    <span v-if="suffix" aria-hidden="true" class="text-xs opacity-70 ml-0.5">{{ suffix }}</span>
  </Atom>
</template>
